<template>
  <div class="d-flex justify-center">
    <v-card class="mx-auto" width="100%" :loading="loading" :disabled="loading">
      <v-card-title>
        <h1 class="pt-4 deep-orange--text">
          {{ $t(levelId > 1 ? "teach_table.title_x" : "teach_table.title") }}
        </h1>
      </v-card-title>
      <v-card-subtitle>
        <h2 class="pt-2">{{ selected_semester }} / {{ translated_year }}</h2>
      </v-card-subtitle>
      <v-card-text class="text-center" v-if="loading">
        <h2>{{ $t("teach_table.searching") }}</h2>
      </v-card-text>
      <v-card-text class="text-center" v-if="is_empty_data">
        <h2>{{ $t(levelId > 1 ? "teach_table.empty_teach_table" : "teach_table.empty_data") }}</h2>
      </v-card-text>
      <v-card-text class="text-center" v-if="error">
        <h2>{{ $t("teach_table.error") }}</h2>
      </v-card-text>
      <!-- ===============================Start Select==================================== -->
      <v-card-text class="text-center px-1 px-md-3 px-xl-3">
        <teach-table-table
          :mode="mode"
          :selected_year="selected_year"
          :selected_semester="selected_semester"
          :selected_faculty="selected_faculty"
          :selected_department="selected_department"
          :selected_curriculum="selected_curriculum"
          :selected_branch="selected_branch"
          :selected_class_year="selected_class_year"
          :search_all_faculty="search_all_faculty"
          :search_all_department="search_all_department"
          :search_all_curriculum="search_all_curriculum"
          :search_all_branch="search_all_branch"
          :search_all_class_year="search_all_class_year"
          :selected_subject_id="selected_subject_id"
          :selected_subject_name="selected_subject_name"
          :selected_subject_owner_id="selected_subject_owner_id"
          :selected_admission_type="selected_admission_type"
          :selected_admission_semester="selected_admission_semester"
          :teach_table_data="teach_table_data"
          :fetch_data="fetch_data"
          :config_permission="config_permission"
          :loading="loading"
          :level_id="levelId"
        />
      </v-card-text>
      <!-- ===============================End Select==================================== -->
    </v-card>

    <div>
      <v-btn class="reload" fab dark color="success" v-on:click="reload()">
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import teachTableProvider from "@/services/teach_table.provider.js";
import TeachTableTable from "./TeachTableTable.vue";
const teachTableService = new teachTableProvider();

export default {
  props: {
    levelId: {
      type: Number,
      default: 1,
    },
  },

  data: function () {
    return {
      mode: null,

      selected_year: null,
      selected_semester: null,

      selected_faculty: null,
      selected_department: null,
      selected_curriculum: null,
      selected_branch: null,
      selected_class_year: null,

      search_all_faculty: null,
      search_all_department: null,
      search_all_curriculum: null,
      search_all_branch: null,
      search_all_class_year: null,

      selected_subject_id: null,
      selected_subject_name: null,

      selected_subject_owner_id: null,
      selected_admission_type: null,
      selected_admission_semester: null,

      teacher_dept: null,

      teach_table_data: [],

      config_permission: { academic_year: [], user_permission: [] },

      loading: true,
      is_empty_data: false,
      error: false,
      fetchRequestId: 0,
    };
  },
  components: {
    TeachTableTable,
  },

  methods: {
    reload() {
      this.$router.go(0);
    },
    async fetch_data() {
      const requestId = ++this.fetchRequestId;
      this.loading = true;
      this.error = false;
      this.is_empty_data = false;
      this.teach_table_data = [];
      this.config_permission = { academic_year: [], user_permission: [] };
      const params = this.$route.query;

      this.mode = params.mode;

      this.selected_year = params.selected_year;
      this.selected_semester = params.selected_semester;

      this.selected_faculty = params.selected_faculty;
      this.selected_department = params.selected_department;
      this.selected_curriculum = params.selected_curriculum;
      this.selected_branch = params.selected_branch;
      this.selected_class_year = params.selected_class_year;

      this.search_all_faculty = params.search_all_faculty;
      this.search_all_department = params.search_all_department;
      this.search_all_curriculum = params.search_all_curriculum;
      this.search_all_branch = params.search_all_branch;
      this.search_all_class_year = params.search_all_class_year;

      this.selected_subject_id = params.selected_subject_id;
      this.selected_subject_name = params.selected_subject_name;

      this.selected_subject_owner_id = params.selected_subject_owner_id;
      this.selected_admission_type = params.selected_admission_type;
      this.selected_admission_semester = params.selected_admission_semester;

      // if (this.$store.state.user.is_officer === true) this.teacher_dept = true; # เอาวงเล็บภาควิชาหลังชื่ออาจารย์ออก

      const teach_table_data = await teachTableService
        .getTeachTableShow({
          level_id: this.levelId,
          mode: this.mode,

          selected_year: this.selected_year,
          selected_semester: this.selected_semester,

          selected_faculty: this.selected_faculty,
          selected_department: this.selected_department,
          selected_curriculum: this.selected_curriculum,
          selected_branch: this.selected_branch,
          selected_class_year: this.selected_class_year,

          search_all_faculty: this.search_all_faculty,
          search_all_department: this.search_all_department,
          search_all_curriculum: this.search_all_curriculum,
          search_all_branch: this.search_all_branch,
          search_all_class_year: this.search_all_class_year,

          selected_subject_id: this.selected_subject_id,
          selected_subject_name: this.selected_subject_name,

          selected_subject_owner_id: this.selected_subject_owner_id,

          selected_admission_type: this.selected_admission_type,
          selected_admission_semester: this.selected_admission_semester,

          teacher_dept: this.teacher_dept,
        })
        .catch((error) => {
          if (requestId !== this.fetchRequestId) return [];
          const message =
            error && error.response && error.response.data
              ? error.response.data.message
              : error.message;
          this.$toasted.error(JSON.stringify(message), {
            duration: 0,
          });
          this.loading = false;
          this.error = true;
          return [];
        });
      if (requestId !== this.fetchRequestId) return;
      this.teach_table_data = teach_table_data;

      if (teach_table_data.length == 0 && !this.error) this.is_empty_data = true;

      if (this.$store.state.user.is_officer === true) {
        try {
          const permission = await teachTableService.getTeachTableConfigDateTime();
          if (requestId !== this.fetchRequestId) return;
          this.config_permission = permission;
        } catch (error) {
          if (requestId !== this.fetchRequestId) return;
          this.$toasted.error(error.message, { duration: 0 });
        }
      }

      this.loading = false;
    },
  },
  computed: {
    translated_year() {
      return this.$root.$i18n.locale === "en"
        ? this.selected_year - 543
        : this.selected_year;
    },
  },
  created() {
    this.fetch_data();
  },
  watch: {
    "$route"() {
      this.$nextTick(() => this.fetch_data());
    },
  },

  mounted: function () {},
};
</script>

<style scoped>
.reload {
  position: fixed;
  right: 130px;
  bottom: 30px;
  z-index: 999;
}
</style>
